// extracted by mini-css-extract-plugin
export default {"card":"Card_card__7rdQE","card_header":"Card_card_header__hdH1Q","title":"Card_title__k+YN0"};